import { render, staticRenderFns } from "./NavProfileComponent.vue?vue&type=template&id=4479ee58&scoped=true&lang=pug&"
import script from "./NavProfileComponent.vue?vue&type=script&lang=js&"
export * from "./NavProfileComponent.vue?vue&type=script&lang=js&"
import style0 from "./NavProfileComponent.vue?vue&type=style&index=0&id=4479ee58&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4479ee58",
  null
  
)

export default component.exports